export default "__VITE_ASSET__BjEkGwsy__"